module.exports = __webpack_public_path__ + "img/eye-on.e9ad1ca4.svg";